export const LOGIN_ROUTE: string  = '/login';
export const REGISTER_ROUTE: string  = '/register';
export const MAIN_ROUTE: string  = '/';
export const ORDER_ROUTE: string  = '/order';
export const ADD_ORDER_ROUTE: string  = '/order';
export const AUTO_ROUTE: string  = '/auto';
export const ADD_AUTO_ROUTE: string  = '/auto';
export const AUTOS_ROUTE: string  = '/autos';
export const CALC_ROUTE: string  = '/calc';
export const NOTFOUND_ROUTE: string  = '/404';